export default {
  FR: "FR",
  IT: "IT",
  EU: "EU",
};
